import { track } from '@amplitude/analytics-browser'

import { trackingEvents } from 'modules/core/lib/Tracking/events'

export type DailyClockInSource =
  | 'mobile_daily_widget'
  | 'desktop_daily_widget'
  | 'timesheet_daily_mobile'
  | 'timesheet_daily_desktop'

export const trackDailyClockIn = (source: DailyClockInSource) => {
  const eventName = trackingEvents.timeTracking.dailyClockIn.clockIn

  track(eventName, {
    source,
    resource_type: 'attendance',
  })
}
